export default "__VITE_ASSET__CmCphdz6__"